import { ResultOption } from './result-option.component';

import { Place } from '@/types/google-maps.types';
import { defaultPlace } from '@/app/(main)/(pages)/(home)/_consts/default-places.const';

type InitialLocationSuggestionsProps = {
  handleLocationClick: (item: Place) => Promise<void>;
};

export const InitialLocationSuggestions = ({
  handleLocationClick,
}: InitialLocationSuggestionsProps) => {
  return (
    <div
      className="flex flex-col gap-5 mb-6"
      data-testid="initial-location-results"
    >
      <p className="text-base leading-6 text-gray-700 font-semibold">
        Cidades mais pesquisadas
      </p>
      {defaultPlace.map((place) => (
        <ResultOption
          key={`key-location-${place.city}`}
          description={place.formattedAddress}
          callback={async () => {
            await handleLocationClick(place);
          }}
        />
      ))}
    </div>
  );
};
